import EntityPage from "@/components/EntityPage";
import { FLIGHT_STATUS, PREPROCESSING_STATUS } from "@/lib/status";

// Block ID sengaja di indeks 0 (kolom pertama tabel) walau bukan identitas baris: satu blok
// boleh punya beberapa flight, jadi `block_id` tidak unik dan tidak bisa dipakai testid/URL.
// `flight_id` yang unik — itu `idKey`, dan itu yang terkunci di form edit.
// `lockOnEdit` mengunci Block ID juga. Itu UI saja (pola yang sama dengan Grid/CP yang tombolnya
// disembunyikan tapi rutenya hidup): PUT langsung masih boleh mengubah `block_id`, dan
// scripts/verify-realisasi.sh membuktikan itu. Perbaikan typo lewat psql.
// `options` di kolom tanggal BUKAN nilai yang disimpan: isinya kosakata dropdown filter
// (`filterCol.options` di EntityPage), sedangkan selnya tetap mencetak tanggalnya sendiri.
// "Sudah"/"Belum" cuma diturunkan dari tanggalnya terisi atau tidak, tidak pernah masuk DB.
const AKUISISI_STATUS = ["Sudah", "Belum"];

const COLUMNS = [
  { key: "block_id", label: "Block ID", type: "text", lockOnEdit: true },
  { key: "flight_id", label: "Flight ID", type: "text" },
  { key: "tanggal_akuisisi", label: "Status Akuisisi", type: "date", options: AKUISISI_STATUS },
  { key: "status_preprocessing", label: "Status Pre Processing", type: "status", options: PREPROCESSING_STATUS },
  { key: "status_foto", label: "Status Proses Foto", type: "status", options: FLIGHT_STATUS },
  { key: "status_lidar", label: "Status Proses Lidar", type: "status", options: FLIGHT_STATUS },
  { key: "luas_ha", label: "Luas (ha)", type: "luas" },
];

export default function FlightsPage() {
  return <EntityPage title="Flight Plan" eyebrow="Modul 01 · Tabular Flight" endpoint="/flights" prefix="flight" columns={COLUMNS} filterKey="tanggal_akuisisi" idKey="flight_id" layerKey="flight-plan" />;
}
